var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrowserIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.8 140.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#abbcd3;}.cls-3{fill:#000201;}.cls-4{fill:#eaedef;}.cls-5{fill:#ccd7dd;}.cls-6{fill:#9ccfce;}.cls-7{fill:#febc2e;}.cls-8{fill:#ff5f57;}.cls-9{fill:#29c940;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.32,
    y: 1.21,
    width: 50.81,
    height: 66.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.32,
    y: 39.64,
    width: 50.81,
    height: 27.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.79,7.88H48.44a.56.56,0,1,1,0-1.12H73.79a.56.56,0,0,1,0,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.67,11.1H48.44a.56.56,0,1,1,0-1.12H64.67a.56.56,0,1,1,0,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.22,14.49H48.44a.56.56,0,1,1,0-1.12h9.78a.56.56,0,1,1,0,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.67,14.49H61.11a.56.56,0,0,1,0-1.12h2.56a.56.56,0,1,1,0,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.75,14.49H67.27a.56.56,0,1,1,0-1.12h3.48a.56.56,0,1,1,0,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.11,17.63H48.44a.56.56,0,1,1,0-1.12H61.11a.56.56,0,1,1,0,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.79,22.51H48.44a.56.56,0,0,1,0-1.12H73.79a.56.56,0,0,1,0,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.67,25.74H48.44a.57.57,0,0,1,0-1.13H64.67a.57.57,0,0,1,0,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.22,29.13H48.44a.56.56,0,0,1-.56-.56.57.57,0,0,1,.56-.57h9.78a.57.57,0,0,1,.56.57A.56.56,0,0,1,58.22,29.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.67,29.13H61.11a.56.56,0,0,1-.56-.56.57.57,0,0,1,.56-.57h2.56a.57.57,0,0,1,.56.57A.56.56,0,0,1,63.67,29.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.75,29.13H67.27a.57.57,0,0,1-.57-.56.58.58,0,0,1,.57-.57h3.48a.57.57,0,0,1,.56.57A.56.56,0,0,1,70.75,29.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.79,32.27H48.44a.56.56,0,0,1,0-1.12H73.79a.56.56,0,1,1,0,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.79,37H48.44a.56.56,0,1,1,0-1.12H73.79a.56.56,0,1,1,0,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.67,40.2H48.44a.56.56,0,0,1,0-1.12H64.67a.56.56,0,0,1,0,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.13,68.5H42.32a1.21,1.21,0,0,1-1.21-1.21V1.21A1.21,1.21,0,0,1,42.32,0H93.13a1.21,1.21,0,0,1,1.21,1.21V67.29A1.21,1.21,0,0,1,93.13,68.5Zm-49.6-2.42H91.92V2.42H43.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.05,
    y: 60.7,
    width: 124.75,
    height: 79.97,
    rx: 8.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1.21,
    y: 45.47,
    width: 121.37,
    height: 89.17,
    rx: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1.93,
    y: 57.68,
    width: 119.72,
    height: 3.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2.03,
    y: 128.59,
    width: 119.72,
    height: 5.12
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62 45.45 44.6 134.67 37.48 134.67 54.87 45.45 62 45.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.08 45.39 77.78 134.61 61.2 134.61 78.6 45.39 95.08 45.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "107.49 45.39 90.1 134.61 82.97 134.61 100.37 45.39 107.49 45.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M10.9,120.24A1.27,1.27,0,0,1,9.63,119V71.33a1.28,1.28,0,0,1,2.55,0V119A1.28,1.28,0,0,1,10.9,120.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.94,70.38H17A1.21,1.21,0,0,1,17,68H57.94a1.21,1.21,0,0,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M43.22,75.59H17a1.21,1.21,0,1,1,0-2.42H43.22a1.21,1.21,0,1,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.81,81.07H17a1.21,1.21,0,0,1,0-2.42h15.8a1.21,1.21,0,1,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41.61,81.07H37.48a1.21,1.21,0,0,1,0-2.42h4.13a1.21,1.21,0,1,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53,81.07H47.41a1.21,1.21,0,0,1,0-2.42H53a1.21,1.21,0,1,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.94,91.21H17a1.21,1.21,0,0,1,0-2.42H57.94a1.21,1.21,0,1,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M43.22,96.42H17A1.21,1.21,0,0,1,17,94H43.22a1.21,1.21,0,1,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.81,101.89H17a1.21,1.21,0,1,1,0-2.42h15.8a1.21,1.21,0,0,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41.61,101.89H37.48a1.21,1.21,0,1,1,0-2.42h4.13a1.21,1.21,0,0,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53,101.89H47.41a1.21,1.21,0,0,1,0-2.42H53a1.21,1.21,0,0,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.48,86.2H17a1.27,1.27,0,1,1,0-2.54H37.48a1.27,1.27,0,0,1,0,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57.94,107H17a1.28,1.28,0,0,1,0-2.55H57.94a1.28,1.28,0,0,1,0,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.94,112H17a1.21,1.21,0,0,1,0-2.42H57.94a1.21,1.21,0,1,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M43.22,117.24H17a1.21,1.21,0,1,1,0-2.42H43.22a1.21,1.21,0,1,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.81,122.72H17a1.21,1.21,0,1,1,0-2.42h15.8a1.21,1.21,0,0,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41.61,122.72H37.48a1.21,1.21,0,0,1,0-2.42h4.13a1.21,1.21,0,0,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53,122.72H47.41a1.21,1.21,0,0,1,0-2.42H53a1.21,1.21,0,0,1,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.62,116.68h-21a.65.65,0,0,1,0-1.3h21a.65.65,0,1,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.07,119.35H91.63a.65.65,0,1,1,0-1.3h13.44a.65.65,0,1,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.73,122.16h-8.1a.65.65,0,1,1,0-1.3h8.1a.65.65,0,1,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.24,122.16h-2.11a.65.65,0,1,1,0-1.3h2.11a.65.65,0,1,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.1,122.16h-2.88a.65.65,0,1,1,0-1.3h2.88a.65.65,0,1,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.62,104.82h-21a.65.65,0,0,1-.65-.65.66.66,0,0,1,.65-.66h21a.66.66,0,0,1,.65.66A.65.65,0,0,1,112.62,104.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.07,107.49H91.63a.66.66,0,0,1,0-1.31h13.44a.66.66,0,0,1,0,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.73,110.29h-8.1a.65.65,0,0,1,0-1.3h8.1a.65.65,0,1,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.24,110.29h-2.11a.65.65,0,1,1,0-1.3h2.11a.65.65,0,1,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.1,110.29h-2.88a.65.65,0,0,1,0-1.3h2.88a.65.65,0,0,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.62,81.09h-21a.66.66,0,0,1-.65-.66.65.65,0,0,1,.65-.65h21a.65.65,0,0,1,.65.65A.66.66,0,0,1,112.62,81.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.07,83.75H91.63a.65.65,0,0,1,0-1.3h13.44a.65.65,0,0,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.73,86.56h-8.1a.65.65,0,0,1,0-1.3h8.1a.65.65,0,1,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.24,86.56h-2.11a.65.65,0,1,1,0-1.3h2.11a.65.65,0,1,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.1,86.56h-2.88a.65.65,0,0,1,0-1.3h2.88a.65.65,0,0,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.62,93h-21a.65.65,0,0,1,0-1.3h21a.65.65,0,0,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.07,95.62H91.63a.65.65,0,0,1,0-1.3h13.44a.65.65,0,0,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.73,98.43h-8.1a.65.65,0,0,1-.65-.65.66.66,0,0,1,.65-.66h8.1a.67.67,0,0,1,.66.66A.66.66,0,0,1,99.73,98.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.24,98.43h-2.11a.66.66,0,0,1-.66-.65.67.67,0,0,1,.66-.66h2.11a.67.67,0,0,1,.66.66A.66.66,0,0,1,104.24,98.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.1,98.43h-2.88a.65.65,0,0,1-.65-.65.66.66,0,0,1,.65-.66h2.88a.66.66,0,0,1,.65.66A.65.65,0,0,1,110.1,98.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.62,69.22h-21a.65.65,0,0,1,0-1.3h21a.65.65,0,0,1,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.07,71.89H91.63a.65.65,0,0,1-.65-.65.66.66,0,0,1,.65-.66h13.44a.66.66,0,0,1,.65.66A.65.65,0,0,1,105.07,71.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.73,74.7h-8.1A.66.66,0,0,1,91,74a.65.65,0,0,1,.65-.65h8.1a.66.66,0,0,1,.66.65A.67.67,0,0,1,99.73,74.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.24,74.7h-2.11a.67.67,0,0,1-.66-.66.66.66,0,0,1,.66-.65h2.11a.66.66,0,0,1,.66.65A.67.67,0,0,1,104.24,74.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.1,74.7h-2.88a.66.66,0,0,1-.65-.66.65.65,0,0,1,.65-.65h2.88a.65.65,0,0,1,.65.65A.66.66,0,0,1,110.1,74.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 10.9,
    cy: 51.34,
    r: 2.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 17.25,
    cy: 51.34,
    r: 2.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 23.59,
    cy: 51.34,
    r: 2.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.49,135.85H6.3A6.3,6.3,0,0,1,0,129.56v-79a6.31,6.31,0,0,1,6.3-6.3H20.53a1.21,1.21,0,0,1,0,2.42H6.3a3.88,3.88,0,0,0-3.88,3.88v79a3.88,3.88,0,0,0,3.88,3.87H117.49a3.88,3.88,0,0,0,3.88-3.87v-79a3.88,3.88,0,0,0-3.88-3.88H28.43a1.21,1.21,0,0,1,0-2.42h89.06a6.31,6.31,0,0,1,6.3,6.3v79A6.3,6.3,0,0,1,117.49,135.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.86,58.43H1.93a.75.75,0,0,1,0-1.5H28.86a.75.75,0,0,1,0,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.65,58.43H35.8a.75.75,0,0,1,0-1.5h85.85a.75.75,0,0,1,0,1.5Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserIcon2);
export default __webpack_public_path__ + "static/media/browser_icon_2.03804cb6d51a8237aab83a26f13f6100.svg";
export { ForwardRef as ReactComponent };